export class CosmosTableRow {
    public initialValue: any;
    public currentValue: any;
}
